import { render, staticRenderFns } from "./CreateMail.vue?vue&type=template&id=100b1d17&"
import script from "./CreateMail.vue?vue&type=script&lang=js&"
export * from "./CreateMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports